import { Settings } from 'lucide-react';
import { useEffect, useState } from 'react';
import './App.css';
import { ChatInterface } from './components/ChatInterface';
import { Login } from './components/Login';
import { SettingsModal } from './components/SettingsModal';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './global.css';

function AppContent() {
    const { user, loading, signOut } = useAuth();
    const [settingsOpen, setSettingsOpen] = useState(false);

    useEffect(() => {
        console.log(`%c[FRONTEND VERSION] ${__BUILD_VERSION__}`, 'color: #4CAF50; font-weight: bold; font-size: 14px');
        console.log('[FRONTEND] Application loaded');
    }, []);

    if (loading) {
        return (
            <div className="app-layout">
                <header className="main-header">
                    <div className="logo-container">
                        <img src="/mitek.png" alt="Mitek Analytics" className="logo-image" />
                    </div>
                    <div className="header-title">Supply Chain AI Tool</div>
                    <div className="header-actions" />
                </header>
                <div className="loading">Loading...</div>
                <footer className="main-footer">
                    <div className="footer-content">
                        &copy; 2026 Mitek Analytics Inc, v1.1.1
                    </div>
                </footer>
            </div>
        );
    }

    if (!user) {
        return (
            <div className="app-layout">
                <header className="main-header">
                    <div className="logo-container">
                        <img src="/mitek.png" alt="Mitek Analytics" className="logo-image" />
                    </div>
                    <div className="header-title">Supply Chain AI Tool</div>
                    <div className="header-actions" />
                </header>
                <div className="main-content">
                    <Login />
                </div>
                <footer className="main-footer">
                    <div className="footer-content">
                        &copy; 2026 Mitek Analytics Inc, v1.1.1
                    </div>
                </footer>
            </div>
        );
    }

    return (
        <div className="app-layout">
            <header className="main-header">
                <div className="logo-container">
                    <img src="/mitek.png" alt="Mitek Analytics" className="logo-image" />
                </div>
                <div className="header-title">Supply Chain AI Tool</div>
                <div className="header-actions">
                    <span className="user-email">Welcome, {user.email}</span>
                    <button onClick={() => { signOut().catch(() => {}); }} className="sign-out-button">Sign Out</button>
                    <button onClick={() => setSettingsOpen(true)} className="settings-button" aria-label="Settings">
                        <Settings size={20} />
                    </button>
                </div>
            </header>
            <div className="main-content">
                <ChatInterface />
            </div>
            <SettingsModal open={settingsOpen} onClose={() => setSettingsOpen(false)} />
            <footer className="main-footer">
                <div className="footer-content">
                    &copy; 2026 Mitek Analytics Inc, v1.1.1
                </div>
            </footer>
        </div>
    );
}

function App() {
    return (
        <AuthProvider>
            <AppContent />
        </AuthProvider>
    );
}

export default App;
